import { featureFlags } from '../../_constants/feature_flags';

export const calculateSetPrice = ( quantity, price, additionalParams ) => {
    const {cashback100} = additionalParams;
    let setPrice = quantity * price;

    if (featureFlags.FEATURE_TYRE_DEALS && cashback100 && quantity > 3) {
        setPrice -= parseInt(quantity / 4) * 100;
    }

    return setPrice;
};

export default calculateSetPrice;
